// Plate codes are stable identifiers; display names preserve Turkish spelling.
const names = [
  'Adana', 'Adıyaman', 'Afyonkarahisar', 'Ağrı', 'Amasya', 'Ankara', 'Antalya',
  'Artvin', 'Aydın', 'Balıkesir', 'Bilecik', 'Bingöl', 'Bitlis', 'Bolu', 'Burdur',
  'Bursa', 'Çanakkale', 'Çankırı', 'Çorum', 'Denizli', 'Diyarbakır', 'Edirne',
  'Elazığ', 'Erzincan', 'Erzurum', 'Eskişehir', 'Gaziantep', 'Giresun', 'Gümüşhane',
  'Hakkari', 'Hatay', 'Isparta', 'Mersin', 'İstanbul', 'İzmir', 'Kars', 'Kastamonu',
  'Kayseri', 'Kırklareli', 'Kırşehir', 'Kocaeli', 'Konya', 'Kütahya', 'Malatya',
  'Manisa', 'Kahramanmaraş', 'Mardin', 'Muğla', 'Muş', 'Nevşehir', 'Niğde', 'Ordu',
  'Rize', 'Sakarya', 'Samsun', 'Siirt', 'Sinop', 'Sivas', 'Tekirdağ', 'Tokat',
  'Trabzon', 'Tunceli', 'Şanlıurfa', 'Uşak', 'Van', 'Yozgat', 'Zonguldak',
  'Aksaray', 'Bayburt', 'Karaman', 'Kırıkkale', 'Batman', 'Şırnak', 'Bartın',
  'Ardahan', 'Iğdır', 'Yalova', 'Karabük', 'Kilis', 'Osmaniye', 'Düzce',
]

export const TURKEY_PROVINCES = names.map((name, index) => ({
  code: String(index + 1).padStart(2, '0'),
  name,
})).sort((a, b) => a.name.localeCompare(b.name, 'tr'))

export function canAccessEmergency(currentUser, userStatus) {
  return Boolean(currentUser?.uid && !currentUser.isAnonymous
    && currentUser.isEmergencyTeamMember === true && userStatus === 'active')
}

export function buildEmergencyScope(scope, provinceCodes) {
  if (!['nationwide', 'provinces'].includes(scope)) throw new Error('Çağrı kapsamını seçin.')
  const codes = [...new Set(provinceCodes)]
  if (scope === 'provinces' && (!codes.length || codes.some((code) => !TURKEY_PROVINCES.some((province) => province.code === code)))) {
    throw new Error('En az bir geçerli il seçin.')
  }
  return {
    scope,
    provinces: scope === 'nationwide' ? TURKEY_PROVINCES : TURKEY_PROVINCES.filter((province) => codes.includes(province.code)),
  }
}
